import eatIcon from '../../assets/eat_slowly_icon.svg';
import spendIcon from '../../assets/spend_gently_icon.png';
import fridgeIcon from '../../assets/fridge_organizer_icon.webp';

import eatTimerKo from '../../assets/screens/eat/ko/timer.webp';
import eatTimerEn from '../../assets/screens/eat/en/timer.webp';
import eatGalleryKo from '../../assets/screens/eat/ko/gallery.webp';
import eatGalleryEn from '../../assets/screens/eat/en/gallery.webp';
import eatStatsKo from '../../assets/screens/eat/ko/stats.webp';
import eatStatsEn from '../../assets/screens/eat/en/stats.webp';
import eatCalendarKo from '../../assets/screens/eat/ko/calendar.webp';
import eatCalendarEn from '../../assets/screens/eat/en/calendar.webp';
import eatDetailKo from '../../assets/screens/eat/ko/detail.webp';
import eatDetailEn from '../../assets/screens/eat/en/detail.webp';
import eatEditorKo from '../../assets/screens/eat/ko/editor.webp';
import eatEditorEn from '../../assets/screens/eat/en/editor.webp';

import spendHomeKo from '../../assets/screens/spend/ko/home.webp';
import spendHomeEn from '../../assets/screens/spend/en/home.webp';
import spendAddKo from '../../assets/screens/spend/ko/add.webp';
import spendAddEn from '../../assets/screens/spend/en/add.webp';
import spendCalendarKo from '../../assets/screens/spend/ko/calendar.webp';
import spendCalendarEn from '../../assets/screens/spend/en/calendar.webp';
import spendChartKo from '../../assets/screens/spend/ko/chart.webp';
import spendChartEn from '../../assets/screens/spend/en/chart.webp';
import spendSearchKo from '../../assets/screens/spend/ko/search.webp';
import spendSearchEn from '../../assets/screens/spend/en/search.webp';
import spendWidgetKo from '../../assets/screens/spend/ko/widget_setting.webp';
import spendWidgetEn from '../../assets/screens/spend/en/widget_setting.webp';

import fridgeHomeKo from '../../assets/screens/fridge/ko/home.webp';
import fridgeHomeEn from '../../assets/screens/fridge/en/home.webp';
import fridgeAddKo from '../../assets/screens/fridge/ko/add.webp';
import fridgeAddEn from '../../assets/screens/fridge/en/add.webp';
import fridgeShoppingKo from '../../assets/screens/fridge/ko/shopping.webp';
import fridgeShoppingEn from '../../assets/screens/fridge/en/shopping.webp';
import fridgeStatsKo from '../../assets/screens/fridge/ko/stats.webp';
import fridgeStatsEn from '../../assets/screens/fridge/en/stats.webp';
import fridgeSearchKo from '../../assets/screens/fridge/ko/search.webp';
import fridgeSearchEn from '../../assets/screens/fridge/en/search.webp';

export const eatSlowly = {
    id: 'eat-slowly',
    accent: 'var(--eat)',
    icon: eatIcon,
    nameKey: 'eat_slowly_name',
    taglineKey: 'eat_slowly_tagline',
    introKey: 'p.eat.intro',
    heroScreen: {ko: eatTimerKo, en: eatTimerEn},
    heroAltKey: 'p.eat.hero_alt',
    appStoreUrl: 'https://apps.apple.com/app/eat-slowly/id6755353645',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.persnormalsoft.eat_slowly',
    privacyPath: '/privacy/eatSlowly',
    privacyNoteKey: 'p.eat.privacy_note',
    features: [
        {key: 'p.eat.f.record', screen: {ko: eatDetailKo, en: eatDetailEn}},
        {key: 'p.eat.f.stats', screen: {ko: eatStatsKo, en: eatStatsEn}},
        {key: 'p.eat.f.calendar', screen: {ko: eatCalendarKo, en: eatCalendarEn}},
    ],
    gallery: [
        {key: 'p.eat.g.gallery', screen: {ko: eatGalleryKo, en: eatGalleryEn}},
        {key: 'p.eat.g.editor', screen: {ko: eatEditorKo, en: eatEditorEn}},
    ],
    extrasKey: 'p.eat.extras',
};

export const spendGently = {
    id: 'spend-gently',
    accent: 'var(--spend)',
    icon: spendIcon,
    nameKey: 'spend_gently_name',
    taglineKey: 'spend_gently_tagline',
    introKey: 'p.spend.intro',
    heroScreen: {ko: spendHomeKo, en: spendHomeEn},
    heroAltKey: 'p.spend.hero_alt',
    appStoreUrl: 'https://apps.apple.com/app/spend-gently-mindful-budget/id6759556305',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.persnormalsoft.spend_gently',
    privacyPath: '/privacy/spendGently',
    privacyNoteKey: 'p.spend.privacy_note',
    features: [
        {key: 'p.spend.f.add', screen: {ko: spendAddKo, en: spendAddEn}},
        {key: 'p.spend.f.calendar', screen: {ko: spendCalendarKo, en: spendCalendarEn}},
        {key: 'p.spend.f.chart', screen: {ko: spendChartKo, en: spendChartEn}},
    ],
    gallery: [
        {key: 'p.spend.g.search', screen: {ko: spendSearchKo, en: spendSearchEn}},
        {key: 'p.spend.g.widget', screen: {ko: spendWidgetKo, en: spendWidgetEn}},
    ],
    extrasKey: 'p.spend.extras',
};

export const fridgeOrganizer = {
    id: 'fridge-organizer',
    accent: 'var(--fridge)',
    icon: fridgeIcon,
    nameKey: 'fridge_organizer_name',
    taglineKey: 'fridge_organizer_tagline',
    introKey: 'p.fridge.intro',
    heroScreen: {ko: fridgeHomeKo, en: fridgeHomeEn},
    heroAltKey: 'p.fridge.hero_alt',
    appStoreUrl: 'https://apps.apple.com/app/fridge-organizer-smart-food/id6797504747',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.persnormal.fridge_organizer',
    privacyPath: '/privacy/fridgeOrganizer',
    privacyNoteKey: 'p.fridge.privacy_note',
    features: [
        {key: 'p.fridge.f.add', screen: {ko: fridgeAddKo, en: fridgeAddEn}},
        {key: 'p.fridge.f.shopping', screen: {ko: fridgeShoppingKo, en: fridgeShoppingEn}},
        {key: 'p.fridge.f.stats', screen: {ko: fridgeStatsKo, en: fridgeStatsEn}},
    ],
    gallery: [
        {key: 'p.fridge.g.home', screen: {ko: fridgeHomeKo, en: fridgeHomeEn}},
        {key: 'p.fridge.g.search', screen: {ko: fridgeSearchKo, en: fridgeSearchEn}},
    ],
    extrasKey: 'p.fridge.extras',
};

export const homeShowcase = {
    eat: {
        screens: {ko: eatTimerKo, en: eatTimerEn},
        secondary: {ko: eatStatsKo, en: eatStatsEn},
    },
    spend: {
        screens: {ko: spendHomeKo, en: spendHomeEn},
        secondary: {ko: spendChartKo, en: spendChartEn},
    },
};
